module.exports = "/images/lines-8.jpg";